/**
 * Cart drawer: tap truncated product titles to show full-name tooltip on touch devices.
 */
(function initAlmCartTitleTooltips() {
  const SELECTOR = '.cart-drawer .cart-items__title[data-tooltip]';
  let openTitle = null;

  function closeTooltip() {
    if (!openTitle) return;
    openTitle.classList.remove('is-tooltip-open');
    openTitle = null;
  }

  function isTouchLike() {
    return window.matchMedia('(hover: none), (pointer: coarse)').matches;
  }

  document.addEventListener(
    'click',
    (event) => {
      const title = event.target.closest(SELECTOR);

      if (!title) {
        closeTooltip();
        return;
      }

      if (!isTouchLike()) return;

      if (openTitle === title) {
        closeTooltip();
        return;
      }

      event.preventDefault();
      closeTooltip();
      title.classList.add('is-tooltip-open');
      openTitle = title;
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeTooltip();
  });
})();
